import { ReminderDisplayMode, ReminderTypes } from '../../Shared/enum';
import { BaseEntity, IBaseEntity } from '../BaseEntity';
import { User } from '../FitnessBox/User';
import { AppModule } from './AppModule';
import { ReminderResponseType } from './ReminderResponseType';
import { ReminderType } from './ReminderType';

export class Reminder extends BaseEntity {
  ReminderId: number;
  ReminderTitle: string;
  ReminderDetails: string;
  ReminderDateTime: Date;
  AllDay: boolean;
  IsCompleted: boolean;
  CompletedOn: Date;
  CompletedBy: User;
  Source: string;
  ReminderType: ReminderTypes;
  RelatedModule: AppModule;
  RelatedModuleName: string;
  RelatedObjectId: number;
  IsActive: boolean;
  CreatedBy: User;
  DisplayMode: ReminderDisplayMode;
  ReminderSubType: ReminderType;
  ReminderResponseType: ReminderResponseType;
}

export interface IReminder {
  ReminderId: number;
  ReminderTitle: string;
  ReminderDetails: string;
  ReminderDateTime: Date;
  AllDay: boolean;
  IsCompleted: boolean;
  CompletedOn: Date;
  CompletedBy: User;
  Source: string;
  ReminderType: ReminderTypes;
  RelatedModule: AppModule;
  RelatedModuleName: string;
  RelatedObjectId: number;
  IsActive: boolean;
  CreatedBy: User;
  DisplayMode: ReminderDisplayMode;
  ReminderSubType: ReminderType;
  ReminderResponseType: ReminderResponseType;
}
